export default "__VITE_ASSET__BEQT4xM4__"